// Onfleet, Routific, Circut, Tookan, Dispatchtrack

export const COMPARISON_ONFLEET = 1;
export const COMPARISON_ROUTIFIC = 2;
export const COMPARISON_CIRCUIT = 3;
export const COMPARISON_TOOKAN = 4;
export const COMPARISON_DISPATCHTRACK = 5;
export const COMPARISON_ELOGII = 6;
export const COMPARISON_ROUTE4ME = 7;

export const COMPARISON = [
  'Control Center',
  ['Customizable Dashboard', 0, 0, 0, 0, 0, 0, 0],
  ['Live field data', 1, 1, 1, 1, 1, 1, 1],
  ['Real time planned vs. actual', 0, 0, 0, 1, 1, 1, 1],
  ['Multiple depots', 1, 1, 1, 1, 1, 1, 1],
  ['Predict and prevent exceptions', 0, 1, 0, 0, 1, 0, 0],
  'AI Route Optimization',
  ['Auto Dispatch', 1, 1, 1, 0, 1, 0, 0],
  ['Standard AI inputs settings', 1, 1, 1, 0, 1, 1, 1],
  ['Extended AI inputs settings', 0, 1, 0, 0, 0, 1, 0],
  ['Dymamic route update', 1, 1, 0, 0, 0, 1, 1],
  ['Custom AI', 0, 0, 0, 0, 0, 1, 0],
  'Customer Portal',
  ['Client brand customization', 1, 0, 0, 0, 0, 0, 1],
  ['Real time updates', 1, 1, 1, 1, 1, 0, 1],
  ['ETA & track driver on map', 1, 1, 0, 1, 0, 1, 0],
  ['Flexible feedback format', 0, 0, 0, 0, 0, 0, 0],
  ['Stand alone & integrated', 0, 0, 1, 1, 0, 0, 0],
  'Driver App',
  ['Realtime updates', 1, 1, 1, 1, 1, 1, 1],
  ['Easy navigation', 1, 1, 1, 1, 1, 1, 1],
  ['All + custom order details', 1, 0, 0, 0, 0, 1, 0],
  ['Flexible checklists', 0, 0, 0, 0, 0, 1, 0],
  ['Unlimited photo uploads', 1, 1, 1, 1, 1, 0, 0],
  'Analytics',
  ['Real time customer feedback', 0, 0, 1, 1, 0, 1, 0],
  ['Driver Performance', 1, 0, 1, 1, 0, 1, 1],
  ['Custom KPIs & reports', 1, 0, 0, 0, 0, 0, 0],
  ['1-year history', 0, 1, 0, 1, 0, 0, 1],
  ['Export data', 1, 0, 1, 0, 0, 1, 1],
  'Integrations',
  ['Integrate any ERP, CRM, Ecommerce', 1, 1, 1, 1, 1, 1, 1],
  ['Webhooks', 1, 1, 1, 1, 1, 1, 1],
  ['Action calls via API', 0, 1, 0, 0, 0, 1, 0],
  ['Custom data points', 0, 0, 1, 1, 1, 0, 0],
  ['Integration support', 0, 1, 1, 1, 1, 0, 1],
];
